function customerDataReducer(state = {
  productData: "", productDataQRCode: "", selectedProductList: [], customerEventList: [],
  customerTicketList: [], noticeBag: [], productGroupSelectList: [], customerProductList:[]
}, action) {

  switch (action.type) {

    case "FETCH_DATA_PRODUCT":
      return {
        ...state,
        productData: action.data
      };

    case "FETCH_DATA_MODELS":
      return {
        ...state,
        models: action.data
      };
    case "ADD_CUSTOMER":
      return {
        ...state,
        result: action.data
      }
    case "FETCH_CURRENT_CUSTOMER":
      return {
        ...state,
        currentCustomer: action.data
      }
    case "FETCH_PRODUCT_BY_QRCODE":
      return {
        ...state,
        productDataQRCode: action.data
      }
    case "SEARCH_PRODUCT_SELECT":
      return {
        ...state,
        selectedProductList: action.data
      }
    case "CUSTOMER_EVENTS":
      return {
        ...state,
        customerEventList: action.data
      }
    case "GET_CUSTOMER_TICKETS":
      return {
        ...state,
        customerTicketList: action.data
      }
    case "GET_CUSTOMER_NOTICES":
      return {
        ...state,
        noticeBag: action.data
      }
    case "GET_PRODUCTGROUP_For_SELECT":
      return {
        ...state,
        productGroupSelectList: action.data
      }
      case "CUSTOMER_PRODUCT_LIST":
        return{
          ...state,
          customerProductList: action.data
        }
    default:
      return state;
  }
}

export default customerDataReducer;